<script setup lang="ts">
const props = defineProps({
	color: {
		type: String,
		default: '',
	},
	width: {
		type: String,
		default: '48',
	},
	height: {
		type: String,
		default: '48',
	},
	strokeWidth: {
		type: String,
		default: '2',
	},
});

const color = computed(() => props.color);
const { color: iconColor } = useIconColor(color);
</script>
<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="user-organizer">
      <path
        id="Icon"
        d="M26.3269 28.8846C25.3637 28.5714 24.18 28.5714 21.8125 28.5714H13.3304C10.9629 28.5714 9.77915 28.5714 8.81592 28.8846C6.6472 29.5897 4.95007 31.4086 4.29219 33.733C4.16021 34.1993 4.08784 34.7138 4.04817 35.3717C3.98473 36.4235 3.95301 36.9494 4.16074 37.4035C4.33645 37.7876 4.66661 38.1382 5.03941 38.3367C5.48013 38.5714 6.05342 38.5714 7.2 38.5714H31.1429M44 25.0714H26.8571M39.2381 19.2857V22.1786M31.619 19.2857V22.1786M35.4286 35V32.1429M35.4286 32.1429V29.2857M35.4286 32.1429H32.5714M35.4286 32.1429H38.2857M25.4286 17.8571C25.4286 22.1965 21.9108 25.7143 17.5714 25.7143C13.232 25.7143 9.71429 22.1965 9.71429 17.8571C9.71429 13.5178 13.232 10 17.5714 10C21.9108 10 25.4286 13.5178 25.4286 17.8571ZM31.4286 38.5714H39.4286C41.0287 38.5714 41.8288 38.5714 42.44 38.2561C42.9776 37.9788 43.4147 37.5362 43.6886 36.9919C44 36.3731 44 35.563 44 33.9429V25.8429C44 24.2227 44 23.4126 43.6886 22.7938C43.4147 22.2495 42.9776 21.8069 42.44 21.5296C41.8288 21.2143 41.0287 21.2143 39.4286 21.2143H31.4286C29.8284 21.2143 29.0283 21.2143 28.4172 21.5296C27.8796 21.8069 27.4425 22.2495 27.1686 22.7938C26.8571 23.4126 26.8571 24.2227 26.8571 25.8429V33.9429C26.8571 35.563 26.8571 36.3731 27.1686 36.9919C27.4425 37.5362 27.8796 37.9788 28.4172 38.2561C29.0283 38.5714 29.8284 38.5714 31.4286 38.5714Z"
        :stroke="iconColor"
        :stroke-width="strokeWidth"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>
